module.exports = __webpack_public_path__ + "static/media/therapitst-landing-icon.10bb7afd.svg";